import WaterIcon from '../images/cards/Cardwaterpool.jpg';
import RoomsIcon from '../images/cards/Cardrooms.jpg';
import RusSauna from '../images/cards/CardRussinsauna.jpg';
import FinSaina from '../images/cards/CardFinSauna.jpg';
import Hamam from '../images/cards/CardHamam.jpg';
import Hamam2 from '../images/cards/CardHamam2.jpg';
import Sauna from '../images/cards/CardSauna.jpg';
import Sauna2 from '../images/cards/CardSauna2.jpg'
import Hall from '../images/cards/hall1.jpeg'
import RusBath2 from '../images/cards/rusbath1.jpeg'

export const CardData = [
  {
    url: WaterIcon,
    title: 'Летний бассейн',
    path: '/waterpool'
  },
  {
    url: RoomsIcon,
    title: 'Гостиничные\n' +
      'номера',
    path: '/rooms'
  },
  {
    url: RusSauna,
    title: 'Русская баня на дровах',
    path: '/russianSauna'
  },
  {
    url: FinSaina,
    title: 'Номер с финской парной и джакузи',
    path: '/finnishRoom'
  },
  {
    url: Hamam,
    title: 'Хамам',
    path: '/hamam'
  },
  {
    url: Hamam2,
    title: 'Хамам 2',
    path: '/hamam2'
  },
  {
    url: Sauna,
    title: 'Сауна №1',
    path: '/sauna'
  },
  {
    url: Sauna2,
    title: 'Сауна №2',
    path: '/sauna2'
  },
   {
    url: Hall,
    title: 'Банкетный зал',
    path: '/hall'
  },
   {
    url: RusBath2,
    title: 'Русская баня',
    path: '/russianBathhouse'
  }
]